import React from 'react';
import { FieldSelect, FieldSelectProps } from '@spotify-internal/anchor-ds';
import { FieldController, HookFormProps } from 'client/shared/FieldController';

export type ControlledFieldSelectProps = HookFormProps &
  Omit<FieldSelectProps, 'error'>;

export const ControlledFieldSelect = (props: ControlledFieldSelectProps) => (
  <FieldController<FieldSelectProps, HTMLSelectElement>
    as={FieldSelect}
    {...props}
  />
);
